import { savePDF } from "@progress/kendo-react-pdf";
import moment from "moment";
import { CSSProperties, useEffect, useRef } from "react";
import { useLocalSampleSummaryParams } from "../../hooks";
import ReportSummaryContainer from "./ReportSummaryContainer";

import useIsPageLoaded from "./hooks/useIsPageLoaded";
import "./report-summary-pdf.module.scss";

type Props = {
  onFinishedDownloading?: () => void;
};

const STYLE: CSSProperties = {
  position: "absolute",
  left: "-1000000px",
  top: 0,
  width: "1440px",
  overflow: "hidden"
};

const ReportSummaryContainerPDFExport = ({ onFinishedDownloading }: Props) => {
  const { hash } = useLocalSampleSummaryParams();

  const isLoaded = useIsPageLoaded();

  const container = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!container.current || !isLoaded) return;

    savePDF(container.current, {
      paperSize: "auto",
      margin: 30,
      fileName: `${hash}_${moment().format("YYYY-MM-DD")}`
    });
    // Wait for the PDF to prepare before calling the callback
    setTimeout(() => {
      onFinishedDownloading?.();
    }, 1000);
  }, [isLoaded, onFinishedDownloading, hash]);

  return (
    <div style={STYLE} ref={container}>
      <div style={{ width: "1500px" }}>
        <ReportSummaryContainer isPdfView />
      </div>
    </div>
  );
};

export default ReportSummaryContainerPDFExport;
